module.exports = __webpack_public_path__ + "media/components/home/creator-community/img/austin-fruits-avatar-482f90afcefd3da4d48b7cba9224f2c0.jpg";